export default {
  // Common
  "Email": "電子郵件",
  "Email *": "電子郵件 *",
  "Password": "密碼",
  "Dashboard": "主頁",
  "Overview": "概要",
  "Giving": "奉獻",
  "GIVING": "奉獻",
  "History": "過往紀錄",
  "Subscriptions": "定期基督徒奉獻",
  "Planned Giving": "定期基督徒奉獻",
  "SUBSCRIPTIONS": "定期基督徒奉獻",
  "Planned Christian Giving": "定期基督徒奉獻",
  "Recurring Instructions": "定期指示",
  "Tax Receipts": "稅務收據",
  "Login": "登入",
  "Logout": "登出",
  "Cancel": "取消",
  "Disabled": "已停用",
  "Do Not Unsubscribe": "不取消訂閱",
  "Confirm": "確認",
  "Complete Payment": "完成付款",
  "Confirm Payment": "確認付款",
  "Processing...": "處理中...",
  "OK": "確定",
  "Type": "類型",
  "Error": "錯誤",
  "Success": "成功",
  "Back": "返回",
  "Save": "儲存",
  "Edit": "編輯",
  "Delete": "刪除",
  "Download": "下載",
  "View": "查看",
  "Actions": "操作",
  "Subscription Ref ID: ": "定期基督徒奉獻參考編號：",
  "Subscription ID": "定期基督徒奉獻編號",
  "Subscription Details": "定期基督徒奉獻詳情",
  "Subscription Status": "定期基督徒奉獻狀態",
  "Start Date": "開始日期",
  "Customer ID": "客戶編號",
  "Token ID": "權杖編號",
  "Unsubscribe": "取消訂閱",
  "Last Payment Date": "上次付款日期",
  "Details": "詳情",
  "Past Givings": "過往奉獻",
  "No past givings found": "沒有找到過往奉獻記錄",
  "Close": "關閉",
  "Are you sure you want to unsubscribe this PCG instruction?": "確定要取消此定期奉獻指示嗎？",
  "The subscription was successfully cancelled.": "訂閱已成功取消。",
  "Subscription Cancelled": "訂閱已取消",
  "Filter": "篩選",
  "Filter Options": "篩選選項",
  "Date (From)": "日期（起）",
  "Date (To)": "日期（止）",
  "Saving...": "儲存中...",
  "Loading...": "載入中...",
  "(Optional)": "(選填)",
  "Password *": "密碼 *",
  "Confirm Password *": "確認密碼 *",
  "Weak Password": "弱密碼",
  "Password does not meet strength requirements. Please check the checklist and try again.": "密碼不符合強度要求。請檢查清單並重試。",
  "Phone": "電話",
  "Service": "聚會時間",
  "Since": "自從",
  "Payment Method": "付款方式",
  "Search": "搜索",
  "Pending": "未完成",
  "Completed": "已完成",
  "Cancelled": "已取消",
  "Enabled": "已啟用",
  "Clear Filters": "清除篩選器",
  "Once": "一次",
  "Monthly": "每月",
  "Yearly": "每年",

  // Receipt Selection
  "Require a receipt": "需要收據",
  "Do not require a receipt": "不需要收據",
  "Receipt No.": "收據編號",

  // Payment Status
  "THANK YOU FOR YOUR SUPPORT!": "感謝您的支持！",
  "PAYMENT FAILED": "付款失敗",

  // HomePage
  "Enter the 6-digit code": "輸入 6 位數驗證碼",
  "Not a member yet?": "還不是會員？",
  "Create an account": "建立帳戶",
  "Forgot Password?": "忘記密碼？",
  "Your account is pending verification. Please check your email for the verification code and": "您的帳戶待驗證。請檢查您的電子郵件以獲取驗證碼，並",
  "enter it in this page": "在此頁面輸入",

  // Registration
  "CREATE ACCOUNT": "建立帳戶",
  "Which Is Your Regular Service?": "您通常參加哪個聚會？",
  "There are errors in the form. Please check the form and try again.": "表單有錯誤。請檢查表單並重試。",
  "Your email is registered but not verified. Please check your email for verification instructions.": "您的電子郵件已註冊但未驗證。請檢查您的電子郵件以獲取驗證說明。",
  "Email Not Verified": "電郵地址未驗證",
  "Creating Account...": "建立帳戶中...",
  "Create Account": "建立帳戶",
  "Only numbers are allowed": "僅允許數字",
  "This field is required": "此欄是必填項",
  "This field must be a valid e-mail": "此欄位必須是有效的電子郵件",
  "Others": "其他",
  "Only English characters are allowed": "僅允許英文字符",
  "Only Chinese characters are allowed": "僅允許中文字符",
  "Must be at least 8 characters long": "必須至少 8 個字符長",
  "Show password": "顯示密碼",
  "Hide password": "隱藏密碼",
  "At least 8 characters": "至少 8 個字符",
  "At least 1 uppercase letter": "至少 1 個大寫字母",
  "At least 1 lowercase letter": "至少 1 個小寫字母",
  "At least 1 number or special character": "至少 1 個數字或特殊字符",

  // Verify Account
  "VERIFY ACCOUNT": "驗證帳戶",
  "Account Verified Successfully!": "帳戶驗證成功！",
  "Your account has been verified. Redirecting to login...": "您的帳戶已驗證。正在重新導向到登入頁面...",
  "A 6-digit verification code has been sent to your email address. Please enter the code below to verify your account.": "已向您的電子郵件地址發送 6 位數驗證碼。請在下方輸入驗證碼以驗證您的帳戶。",
  "Verification failed. Please check your code and try again.": "驗證失敗。請檢查您的驗證碼並重試。",
  "6-Digit Verification Code": "6 位數驗證碼",
  "000000": "000000",
  "Didn't receive the code?": "沒有收到驗證碼？",
  "Resending...": "重新發送中...",
  "Resend in {{count}}s": "{{count}}秒後重新發送",
  "Resend Code": "重新發送驗證碼",
  "Verifying...": "驗證中...",
  "Verify Account": "驗證帳戶",
  "Back to Login": "返回登入頁面",
  "A new verification code has been sent to your email.": "新的驗證碼已發送到您的電子郵件。",
  "Code Resent": "驗證碼重發",
  "Failed to resend verification code. Please try again.": "無法重新發送驗證碼。請重試。",
  "Please enter a valid 6-digit verification code.": "請輸入有效的 6 位數驗證碼。",
  "Invalid Input": "輸入無效",
  "Email is required to resend verification code.": "需要電子郵件才能重新發送驗證碼。",

  // Forgot Password
  "FORGOT PASSWORD": "忘記密碼",
  "Enter your email address and we'll send you a verification code to reset your password.": "輸入您的電子郵件地址，我們會向您發送驗證碼以重設密碼。",
  "Failed to send verification code. Please try again.": "無法發送驗證碼。請重試。",
  "your.email@example.com": "your.email@example.com",
  "Please enter a valid email address.": "請輸入有效的電子郵件地址。",
  "Sending...": "發送中...",
  "Send Verification Code": "發送驗證碼",

  // Verify Code
  "VERIFY CODE": "驗證驗證碼",
  "A 6-digit verification code has been sent to your email address. Please enter the code below to continue.": "已向您的電子郵件地址發送 6 位數驗證碼。請在下方輸入驗證碼以繼續。",
  "Verify Code": "驗證驗證碼",
  "Back to Forgot Password": "返回\"忘記密碼\"",

  // Reset Password
  "RESET PASSWORD": "重設密碼",
  "Enter your new password below.": "在下方輸入您的新密碼。",
  "Failed to reset password. Please try again.": "無法重設密碼。請重試。",
  "New Password": "新密碼",
  "Password must be at least 8 characters": "密碼必須至少 8 個字元",
  "Enter new password": "輸入新密碼",
  "Confirm New Password": "確認新密碼",
  "Passwords do not match": "密碼錯誤",
  "Re-enter your new password": "重新輸入您的新密碼",
  "Your password has been successfully reset. You can now login with your new password.": "您的密碼已成功重設。您現在可以使用新密碼登入。",
  "Password Reset Successful": "密碼重設成功",
  "Passwords do not match. Please try again.": "密碼錯誤。請重試。",
  "Password Mismatch": "密碼錯誤",
  "Please fill in all required fields correctly.": "請正確填寫必要項目。",
  "Resetting...": "重設中...",
  "Reset Password": "重設密碼",

  // Dashboard
  "Give": "奉獻",
  "PCGID: ": "PCGID: ",
  "Last Giving": "上次奉獻",
  "Giver for ": "奉獻者 ",
  "month": "個月",
  "months": "個月",
  "HKD": "港幣",
  "Total Amount (Fiscal Year To Date)": "總金額（本財政年度至今）",
  "RECENT GIVING": "最近奉獻",
  "Date": "日期",
  "Amount": "金額",
  "Fund": "基金",
  "Next Billing Date": "下次扣款日期",
  "Recurring Monthly Amount": "每月定期奉獻金額",
  "Status": "狀態",
  "Ref ID": "參考編號",
  "No recent giving found": "未找到最近的奉獻",

  // Give Page
  "FREQUENCY": "頻率",
  "AMOUNT": "金額",
  "PAYMENT CONFIRMATION": "付款確認",
  "Please Note: By choosing 'Do Not Require A Receipt', no receipt shall be issued or requested in the future regards to the giving, yet email is compulsory for each giving for issuing confirmation email and documentation purpose.": "請注意：選擇「不需要收據」後，本堂將不會就是次奉獻發出收據，每次奉獻都必須提供電郵地址以作核實及存檔。",
  "Click this button to proceed to the QFPay payment page": "點擊此按鈕前往 QFPay 付款頁面",
  "GIVE ": "奉獻 ",
  " NOW": " 立即",
  "GIVE {{amount}} NOW": "立即奉獻{{amount}}",
  "Payment Failed": "付款失敗",
  "An error occurred during payment. Please try again.": "付款過程中發生錯誤。請重試。",

  // History
  "HISTORY": "過往紀錄",
  "GIVING RECORD": "奉獻記錄",

  // Subscriptions
  "Planned Amount": "定期奉獻金額",
  "Planned Status": "定期奉獻狀態",

  // Profile
  "Profile": "資料",
  "MY PROFILE": "我的資料",
  "Personal Information": "個人資訊",
  "First Name (English) *": "名字（英文）*",
  "Last Name (English) *": "姓氏（英文）*",
  "First Name (Chinese)": "名字（中文）",
  "Last Name (Chinese)": "姓氏（中文）",
  "Name on Tax Receipt": "稅務收據上的名字",
  "Name on Tax Receipt *": "稅務收據上的名字 *",
  "Used for issuing tax receipt. Default to First Name and Last Name": "用於發出稅務收據。預設為名字和姓氏",
  "Phone *": "電話 *",
  "Change Password (Optional)": "更改密碼（可選）",
  "Leave password fields blank if you don't want to change your password.": "如果您不想更改密碼，請將密碼欄位留空。",
  "Current Password": "目前密碼",
  "Your profile has been updated successfully.": "您的資料已成功更新。",
  "Save Profile": "儲存資料",

  // Receipts
  "TAX RECEIPTS": "稅務收據",
  "ISSUED TAX RECEIPTS": "已發出的稅務收據",
  "Financial Year:": "財政年度：",

  // Not Found
  "Page not found": "找不到頁面",
  "Redirecting to dashboard in ": "重新導向到主頁於 ",

  // Portal Header
  "The login session is expired. Please login again.": "登入階段已過期。請重新登入。",
  "Are you sure you want to logout?": "您確定要登出嗎？",

  // File Upload
  "Drop file here to upload": "將檔案拖放到此處上傳",
  "Drop file here or click to upload.": "將檔案拖放到此處或點擊上傳。",
  "Accept file upload within 10 MB": "接受 10 MB 以內的檔案上傳",

  // General List Layout
  "The ": "該 ",
  " is sent to the customer successfully.": " 已成功發送給客戶。",
  " Sent": " 已發送",
  "Failed to send the ": "無法發送 ",
  " to the customer.": " 給客戶。",
  "Failed to Send ": "發送失敗 ",
  "Selected ": "已選擇 ",
  "Item": "項目",
  "Items": "項目",

  // Delete Dialog
  "Delete ": "刪除 ",
  "Are you sure you want to delete this ": "您確定要刪除此 ",

  // View Page Header
  "View ": "查看 ",

  // Entry Pages - additional keys
  "100.00": "100.00",
  "You have successfully made a {{term}} giving to": "您已成功作出{{term}}捐獻至",
  "Amount: HKD ": "金額：港幣 ",
  "Ref ID: ": "參考編號：",
  "You can view your giving history in the": "您可以在",
  "history": "過往紀錄",
  "section": "部分查看您的捐獻記錄",
  "A confirmation email has been sent to your email address.": "確認電郵已發送至您的電郵地址。",
  "Unfortunately, your payment for the giving to": "很抱歉，您捐獻至",
  "Unfortunately, your payment for the giving to ": "很抱歉，您捐獻至 ",
  "could not be processed": "的付款無法處理",
  " could not be processed.": " 的付款無法處理。",
  "Please check your payment details and try again": "請檢查您的付款詳情並重試",
  "Please check your payment details and try again.": "請檢查您的付款詳情並重試。",
  "TRY AGAIN": "重試",
  "Need help": "需要協助",
  "Contact Support": "聯絡支援",
  "Need help?": "需要幫助嗎？請聯絡該<hyperlink>機構</hyperlink>尋求協助。",

  // Confirmation Page
  "Confirm Recurring Payment": "確認定期捐獻",
  "Please review your recurring payment details before confirming": "請在確認前檢查您的定期捐獻詳情",
  "Confirm and Proceed to Payment": "確認並前往付款",
  "Edit Details": "編輯詳情",
};
